<template>
  <ul class="user-actions">
    <li class="user-actions__item user-actions__item--bonuses">
      <header-bonuses-info></header-bonuses-info>
    </li>
    <li id="esputnik-bell-wrapper"></li>
    <header-user></header-user>
    <header-wishlist></header-wishlist>
    <header-comparison class="user-actions__item user-actions__item--comparison"></header-comparison>
    <header-cart class="user-actions__item user-actions__item--cart"></header-cart>
    <slot></slot>
  </ul>
</template>

<script>
import { mapActions } from 'vuex'
import HeaderBonusesInfo from '@/components/header/HeaderBonusesInfo'
import HeaderUser from '@/components/header/HeaderUser'
import HeaderWishlist from '@/components/header/HeaderWishlist'
import HeaderComparison from '@/components/product/product-comparison/HeaderComparison'
import HeaderCart from '@/components/cart/HeaderCart'

export default {
  name: 'UserActions',
  components: {
    HeaderBonusesInfo,
    HeaderUser,
    HeaderWishlist,
    HeaderComparison,
    HeaderCart
  },
  methods: {
    ...mapActions(['FETCH_INITIAL_INFO', 'FETCH_USER_DATA', 'FETCH_BONUSES_INFO'])
  },
  mounted () {
    this.FETCH_USER_DATA({
      fields: ['name', 'phone', 'last_name', 'father_name', 'email', 'social', 'birthday', 'gender', 'language']
    }).then(res => {
      if (res.auth) {
        this.FETCH_BONUSES_INFO()
      }
      this.FETCH_INITIAL_INFO()
    })
  }
}
</script>

<style scoped lang="sass">
::v-deep
  .js-pull-notification-call-button-host-element
    margin-left: 5px

    +mmin($tablet--hor)
      margin-left: 10px

    &:hover
      background-color: #f2f2f2

</style>
